<template>
  <div
    class="modal fade"
    :id="id"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog" :style="'margin-top:-' + height / 2 + 'px;'">
      <div
        class="video-wrap"
        :style="'width:' + width + 'px; height:' + height + 'px;'"
      >
        <a
          class="icon icon-remove text-right text-white"
          @click.prevent="$emit('close')"
          title="Close"
          data-dismiss="modal"
          aria-label="Close"
        ></a>
        <iframe
          :src="iframeUrl"
          frameborder="no"
          allowfullscreen
          webkitallowfullscreen
          mozallowfullscreen
          :style="iframeStyle"
        >
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "video-modal",
      defaultWidth: 640,
      defaultHeight: 360,
    };
  },
  computed: {
    videoUrl: function () {
      return !_.isEmpty(this.options) && _.has(this.options, "videoUrl")
        ? this.options.videoUrl
        : "";
    },
    width: function () {
      return !_.isEmpty(this.options) &&
        _.has(this.options, "width") &&
        this.options.width
        ? this.options.width
        : this.defaultWidth;
    },
    height: function () {
      return !_.isEmpty(this.options) &&
        _.has(this.options, "height") &&
        this.options.height
        ? this.options.height
        : this.defaultHeight;
    },
    iframeUrl: function () {
      var url = this.route("asset.video");
      url += "?video_url=" + encodeURIComponent(this.videoUrl);
      return url;
    },
    iframeStyle: function () {
      var style = "width:" + this.width + "px;";
      style += " height:" + this.height + "px;";
      style += " background-color:#000000;";
      return style;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal .modal-dialog {
  max-width: none;
  pointer-events: auto;
  text-align: center;
  top: 50vh;

  .video-wrap {
    position: relative;
    margin: 0 auto;

    .icon-remove {
      position: absolute;
      top: -0.5rem;
      right: -1.5rem;
      cursor: pointer;
    }
  }
}
</style>
